<template>
  <div class="avatar-with-cropper" @click="showCropper = true">
    <div class="avatar-with-cropper__content"> 
      <CIcon icon="camera-photo-icon" />
      <div class="avatar-with-cropper__tip">Добавить фото</div>
    </div>
    <img
      v-if="avatar"
      :src="apiUrl + 'download/avatar/user/'+avatar"
    />
  
  </div>
  <CustomAvatarCropper
      v-model="showCropper"
      :upload-url=" userId ? apiUrl + 'upload/avatar/user/'+userId : apiUrl + 'upload/avatar/user'"
      @uploaded="handleUploaded"
      @error="handleError"
      :labels="labels"
      :request-options="headers"
    />
</template>

<script setup>
import { ref, defineProps, defineEmits} from "vue";

import { usePopupStore } from "@/store/popupStore";
import { apiUrl } from "@/service/user.service"
import { customStorage } from "@/service/customStorage";
import CustomAvatarCropper from "@/components/CustomAvatarCropper.vue";
import CIcon from "@/elements/CIcon.vue";

const props = defineProps({
  avatar: { type: String, required: false },
  userId: { type: Number, required: false }
});
const { showPopup } = usePopupStore();
const emits = defineEmits(["update"]);

const showCropper = ref(false);
const labels = { submit: "Сохранить", cancel: "Отмена" };
const headers = {
  method: "POST",
  headers: { Authorization: "Bearer " + customStorage.get("user-token") },
  responseType: "blob",
};

function handleUploaded() {
  showPopup("Аватар загружен!", "success");
  emits("update");
}



function handleError() {
  showPopup("Произошла ошибка, попробуйте ещё раз!", "error");
}
</script>

<style lang="scss">
.avatar-with-cropper {
  width: 200px;
  height: 200px;
  background-size: 200% auto;
  background-image: linear-gradient(
    to right,
    #e08ef2 0%,
    #edacff 51%,
    #deceff 100%
  );
  transition: all 0.2s;
  border-radius: 4px;
  max-width: 770px;
  box-shadow: #fff;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  overflow: hidden;


  svg {
    stroke: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30%;
    height: auto;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__content {
    overflow: hidden;
    display: flex;
    border-radius: 8px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  &__tip {
    color: #fff;
    background-color: rgba(#f99ade, 0.6);
    width: 100%;
    position: absolute;
    bottom: -100%;
    padding: 8px;
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s;
  }

  &:hover {
    background-position: right center;

    .avatar-with-cropper__tip {
      bottom: 0;
    }
  }
}
</style>
